import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders,HttpErrorResponse,HttpResponse } from '@angular/common/http';
import { Headers, Request, RequestOptions, RequestMethod, Response } from '@angular/http';
import 'rxjs/add/operator/map'; 
import 'rxjs/add/operator/catch'; 
import 'rxjs/add/operator/do'
import 'rxjs/add/observable/throw'; 
import {Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Customer } from './customer';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { Logging } from '../../logging';

@Injectable()
export class CustomerService {

  private baseUrl = environment.apiUrl;

  constructor(private http:HttpClient) { }

  
  getData(url:string):Observable<Customer[]> {

    const full_url:string = `${this.baseUrl}${url}`;

    // now returns an Observable of Config
    return this.http.get<Customer[]>(full_url)
    .do(data => Logging.log('All : ' + JSON.stringify(data))).catch(this.handleError);;

  }

  private handleError (error: Response | any) {
    // console.error('ApiService::handleError', error);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/customer/customer.service.ts